import tableNames from 'constants/tableNames';

export const tableRoutes = {
  [tableNames.rcs]: 'bwlist',
};
